import React, { useState } from "react";
import { api, errMsg } from "../lib/api";
import { ShieldQuestion, Loader2 } from "lucide-react";

export default function QuestionsGate({ t, user, onDone }) {
  const s = t.secq;
  const [rows, setRows] = useState([{ q: s.list[0], r: "" }, { q: s.list[1], r: "" }]);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (i, k, v) => setRows(rows.map((r, j) => (i === j ? { ...r, [k]: v } : r)));

  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    if (rows[0].q === rows[1].q) return setErr(s.distinct);
    if (rows.some((r) => r.r.trim().length < 2)) return setErr(s.tooShort);
    setBusy(true);
    try { await api.definirQuestions(rows); onDone(); } catch (ex) { setErr(errMsg(ex)); }
    setBusy(false);
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1900, background: "rgba(15,23,42,0.55)", backdropFilter: "blur(6px)", display: "grid", placeItems: "center", padding: 16, overflowY: "auto" }} data-testid="questions-gate">
      <form onSubmit={submit} className="card fade-up w-full" style={{ maxWidth: 520, padding: 32, background: "var(--bg)" }}>
        <div className="eyebrow mb-3 flex items-center gap-2"><ShieldQuestion size={13} />{s.eyebrow}</div>
        <h2 className="font-h text-2xl mb-2">{s.title}</h2>
        <p className="text-sm mb-6" style={{ color: "var(--tx2)" }}>{s.sub} <span className="font-m">{user.email}</span></p>
        {rows.map((r, i) => (
          <div key={i} className="mb-4">
            <label className="eyebrow block mb-1.5">{s.question} {i + 1}</label>
            <select className="inp mb-2" value={r.q} onChange={(e) => set(i, "q", e.target.value)} data-testid={`secq-select-${i}`}>
              {s.list.map((q) => <option key={q} value={q}>{q}</option>)}
            </select>
            <input className="inp" placeholder={s.answer} value={r.r} onChange={(e) => set(i, "r", e.target.value)} data-testid={`secq-answer-${i}`} />
          </div>
        ))}
        <p className="text-xs mb-4" style={{ color: "var(--tx3)" }}>{s.hint}</p>
        {err && <div className="text-sm mb-4 px-3 py-2" style={{ background: "rgba(220,38,38,0.08)", color: "var(--red)" }} data-testid="secq-error">{err}</div>}
        <button className="btn btn-primary w-full justify-center" disabled={busy} data-testid="secq-submit">{busy ? <Loader2 size={15} className="animate-spin" /> : <ShieldQuestion size={15} />}{s.save}</button>
      </form>
    </div>
  );
}
